import React, { forwardRef, useContext } from "react";
import clsx from "clsx";
import { mergeStyles } from "react-select";
import { AsyncPaginate as ReactSelectAsync } from "react-select-async-paginate";

import { Skeleton } from "components";
import { BrandingColorContext } from "components/contexts";

import DropdownIndicator from "./dropdownIndicator";
import { selectStyles } from "./selectStyles";

import classes from "./selectAsync.module.scss";

/**
 * @type {any}
 */
const SelectAsync = forwardRef(
	(
		{
			loading,
			loaderClassName,
			styles: customSelectStyles = {},
			components: customComponents = {},
			...props
		},
		ref,
	) => {
		const brandingColor =
			useContext(BrandingColorContext) || props.brandingColor;

		const styles = mergeStyles(selectStyles, customSelectStyles);

		const components = {
			DropdownIndicator,
			...customComponents,
		};

		return (
			<div
				className={clsx(classes.selectLoaderContainer, loaderClassName)}
			>
				{loading && (
					<Skeleton
						height="34px"
						className={classes.selectLoaderContainerSkeleton}
					/>
				)}
				<ReactSelectAsync
					selectRef={ref}
					className="react-select-container"
					classNamePrefix="react-select"
					styles={styles}
					components={components}
					brandingColor={brandingColor}
					{...props}
				/>
			</div>
		);
	},
);

export default SelectAsync;
